import * as React from "react";
import {Link} from "react-router";

type KpiCardProps = {
    label: string
    value: string
    sub?: string
    trend?: 'up' | 'down' | 'neutral'
    to?: string // makes the whole card a link
}

const KpiCard: React.FC<KpiCardProps> = ({label, value, sub, trend, to}) => {
    const subColor = trend === 'up' ? 'text-green-600' : trend === 'down' ? 'text-red-600' : 'text-gray-500';
    const content = (
        <>
            <dt className="text-sm font-medium text-gray-500 uppercase truncate">{label}</dt>
            <dd className="mt-1 text-2xl font-semibold text-gray-900">{value}</dd>
            {sub && <dd className={`mt-1 text-sm ${subColor}`}>{sub}</dd>}
        </>
    );
    const className = "bg-white overflow-hidden shadow-sm px-4 py-5 sm:p-6";
    return to
        ? <Link to={to} className={`block ${className} hover:bg-gray-50`}>{content}</Link>
        : <div className={className}>{content}</div>;
};

export default KpiCard;
